import React from 'react';
import { Card, Typography } from 'antd';
import { Navigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import authService from '../services/auth';

const { Title } = Typography;

const Login = () => {
  if (authService.isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f0f2f5'
    }}>
      <Card style={{ width: 400 }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 32 }}>
          登录
        </Title>
        <LoginForm />
      </Card>
    </div>
  );
};

export default Login;
